export default __webpack_public_path__ + "static/banner-bg-a521c94de9f43fe862f476dd318e5a41.png";